// Ported verbatim from the mobile app (PrecisionReactNative src/common/assets/images/equipment/eqGymEquipmentSVG.tsx); generated — regenerate rather than edit.
import * as React from "react";

type Props = {
  fill: string;
  width?: number;
  height?: number;
};

function EqGymEquipmentSvg(props: Props) {
  const {fill, width = 16, height = 16} = props;
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none">
      <path
        d="M6.5 2C5.96957 2 5.46086 2.21071 5.08579 2.58579C4.71071 2.96086 4.5 3.46957 4.5 4V8V10V14V15H2.5V14V10H1.5H0.5V8H1.5H2.5V4C2.5 2.93913 2.92143 1.92172 3.67157 1.17157C4.42172 0.421427 5.43913 0 6.5 0H18.5C19.5609 0 20.5783 0.421427 21.3284 1.17157C22.0786 1.92172 22.5 2.93913 22.5 4V8H23.5H24.5V10H23.5H22.5V14V15H20.5V14V10V8V4C20.5 3.46957 20.2893 2.96086 19.9142 2.58579C19.5391 2.21071 19.0304 2 18.5 2H6.5ZM7.5 17H6.5V19H7.5H11.5V22H9.5H8.5V24H9.5H15.5H16.5V22H15.5H13.5V19H17.5H18.5V17H17.5H7.5ZM10.5 5C9.96957 5 9.46086 5.21071 9.08579 5.58579C8.71071 5.96086 8.5 6.46957 8.5 7V15V16H10.5V15V7H14.5V15V16H16.5V15V7C16.5 6.46957 16.2893 5.96086 15.9142 5.58579C15.5391 5.21071 15.0304 5 14.5 5H10.5Z"
        fill={fill}
      />
    </svg>
  );
}

export default EqGymEquipmentSvg;
